module.exports = __webpack_public_path__ + "assets/img/Australian-Seniors-Landing-Page-w540.006c9aee.jpg";